/* @sravni/react-design-system version 0.2.71 */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { isBrowser } from '@sravni/react-utils';

var portalContainer;
var portalAttribute = 'sr-portal-container';
var Portal = React.memo(function (props) {
    var children = props.children;
    var portal = React.useMemo(function () {
        if (!isBrowser) {
            return null;
        }
        if (portalContainer) {
            return portalContainer;
        }
        var el = document.querySelector("div[".concat(portalAttribute, "]"));
        if (el) {
            portalContainer = el;
            return portalContainer;
        }
        portalContainer = document.createElement('div');
        portalContainer.setAttribute(portalAttribute, '');
        document.body.appendChild(portalContainer);
        return portalContainer;
    }, []);
    if (!isBrowser) {
        return null;
    }
    if (portal) {
        return ReactDOM.createPortal(children, portal);
    }
    return null;
});
Portal.displayName = 'Portal';

export { Portal };
//# sourceMappingURL=Portal.js.map
